"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.Context = React.createContext({
    storeLocator: null,
});
//# sourceMappingURL=context.js.map